import { useState, useEffect, useCallback } from "react";
import {
  fetchSuppliers as apiFetchSuppliers,
  updateSupplier as apiUpdateSupplier,
} from "../services/suppliersService";

// Хук керує станом та логікою для налаштувань постачальників
const useSuppliers = () => {
  const [suppliers, setSuppliers] = useState([]);

  // Завантажує список постачальників з сервера
  const fetchData = useCallback(async () => {
    try {
      const data = await apiFetchSuppliers();
      setSuppliers(data);
    } catch (err) {
      console.error("Помилка завантаження постачальників:", err);
    }
  }, []);

  // Ефект для початкової ініціалізації при першому завантаженні сторінки
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Оптимістично оновлює дані одного постачальника
  const updateSupplier = useCallback(
    async (supplierId, fields) => {
      try {
        await apiUpdateSupplier(supplierId, fields);
        setSuppliers((prev) =>
          prev.map((s) => (s.id === supplierId ? { ...s, ...fields } : s)),
        );
      } catch (err) {
        console.error(`Помилка оновлення постачальника з id ${supplierId}:`, err);
      } finally {
        fetchData();
      }
    },
    [fetchData],
  );

  return { suppliers, refresh: fetchData, updateSupplier };
};

export default useSuppliers;
